export const getData = state => state.userList.data.data || [];
export const getIsFetching = state => state.userList.isFetching;
export const getTotalPages = state => state.userList.data.page.total || 0;
export const getTotalRow = state => state.userList.data.page.totalRow || 0;
export const getPage = state => state.userList.data.page.current || 0;
